import { useContext } from "react";
import useSWRMutation from "swr/mutation";
import { environment } from "../config/environment";
import { ToastContext } from "../context/ToastContext";
import { useSWRFetcher } from "./useSWRFetcher";

export const useRemittanceComplete = (invoiceId?: string) => {
  const fetcher = useSWRFetcher();
  const { showToast } = useContext(ToastContext);

  const { trigger, isMutating, error } = useSWRMutation(
    invoiceId ? `${environment.apiUrl}/api/payables/tasks/remittance/complete/${invoiceId}` : null,
    (url: string) => fetcher<{ result: string }>(url, { method: "POST" }),
    {
      onError: () => {
        showToast("Failed to mark as complete, please try again later", "error");
      },
    }
  );

  return {
    complete: trigger,
    isLoading: isMutating,
    isError: !!error,
  };
};
